import { FC } from 'react';

type Props = {
	className?: string;
};

const ArrowRightIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M9.5 14L12.7929 10.7071C13.1262 10.3738 13.2929 10.2071 13.2929 10C13.2929 9.79289 13.1262 9.62623 12.7929 9.29289L9.5 6'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ArrowRightIcon;
